
class ChangePasswordController {
  constructor (Localization, ValidationRules, UserService, VehicleService, $state, $stateParams, I18n, $rootScope) {
    'ngInject'
    this.I18n = I18n
    this.userService = UserService
    this.vehicleService = VehicleService
    this.validationRules = ValidationRules
    this.$state = $state
    this.$stateParams = $stateParams
    this.$rootScope = $rootScope
    this.isProcessing = false
    this.updatePassword = {}
    this.isValidOldPassword = true
    this.isWrongOldPassword = false
  }

  changePassword (form) {
    if (form.changePasswordForm.$valid) {
      this.isProcessing = true
      this.isValidOldPassword = true
      return this.userService.changePassword(this.updatePassword.oldPassword, this.updatePassword.newPassword)
      .then((success) => {
        this.userService.logout()
          .then(() => {
            return this.$state.go('home', {success: 'my-updates.update_success'})
          })
      }, (err) => {
        this.error = err
        if (this.error.data.meta.code === 524) {
          this.errorCode = this.error.data.meta.code
        }
        if (this.error.data.meta.statusCode === 403) {
          this.isWrongOldPassword = true
        }
        this.isProcessing = false
      })
    }
  }

  /**
   * validate old password
   * it should match the old password patter or with checkPassword WS
   * @returns {boolean}
   */
  validateOldPassword () {
    this.isValidOldPassword = true
    if (this.updatePassword.oldPassword && this.updatePassword.oldPassword.length >= 8 && this.updatePassword.oldPassword.length <= 32) {
      let isMatchOldPattern = this.updatePassword.oldPassword.match(this.validationRules.password.pattern)
      if (isMatchOldPattern === null) {
        this.userService.checkPassword(this.updatePassword.oldpassword).then((valid) => {
          this.isValidOldPassword = true
          return Promise.resolve()
        }, (err) => {
          this.isValidOldPassword = false
          return Promise.reject(err)
        })
      }
    }
    return this.isValidOldPassword
  }

}

export default ChangePasswordController



// WEBPACK FOOTER //
// ./src/app/pages/change-password/change-password.controller.js